var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.00012C0 8.6686 0.131696 8.35065 0.366117 8.11623C0.600537 7.88181 0.918479 7.75012 1.25 7.75012H15.7325L10.365 2.38512C10.1303 2.1504 9.99842 1.83205 9.99842 1.50011C9.99842 1.16818 10.1303 0.849831 10.365 0.615115C10.5997 0.380398 10.9181 0.248535 11.25 0.248535C11.5819 0.248535 11.9003 0.380398 12.135 0.615115L19.635 8.11512C19.7514 8.23123 19.8438 8.36917 19.9068 8.52103C19.9698 8.67289 20.0022 8.8357 20.0022 9.00012C20.0022 9.16453 19.9698 9.32734 19.9068 9.4792C19.8438 9.63106 19.7514 9.769 19.635 9.88512L12.135 17.3851C11.9003 17.6198 11.5819 17.7517 11.25 17.7517C10.9181 17.7517 10.5997 17.6198 10.365 17.3851C10.1303 17.1504 9.99842 16.8321 9.99842 16.5001C9.99842 16.1682 10.1303 15.8498 10.365 15.6151L15.7325 10.2501H1.25C0.918479 10.2501 0.600537 10.1184 0.366117 9.884C0.131696 9.64958 0 9.33164 0 9.00012Z",
    fill: "#1EBB60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowGreen);
export default __webpack_public_path__ + "static/media/right-arrow-green.f8a8607f9ff5113b1c1f59d5d6efd8b5.svg";
export { ForwardRef as ReactComponent };